import { render, staticRenderFns } from "./ResultDetail.vue?vue&type=template&id=3541a8b2&scoped=true&"
import script from "./ResultDetail.vue?vue&type=script&lang=js&"
export * from "./ResultDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3541a8b2",
  null
  
)

export default component.exports